export function deepMerge<T extends object, U extends object>(
  target: T,
  source: U,
): T & U {
  const output = { ...target, ...source } as T & U;
  Object.keys(source).forEach(key => {
    const sourceValue = source[key as keyof U];
    const targetValue = (target as Record<string, unknown>)[key];
    if (
      sourceValue &&
      typeof sourceValue === 'object' &&
      !Array.isArray(sourceValue) &&
      targetValue &&
      typeof targetValue === 'object' &&
      !Array.isArray(targetValue)
    ) {
      (output as Record<string, unknown>)[key] = deepMerge(
        targetValue as object,
        sourceValue as object,
      );
    } else if (sourceValue !== undefined) {
      (output as Record<string, unknown>)[key] = sourceValue;
    }
  });
  return output;
}
